import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/ChatIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from './Button.js';

const BackButton = (_a) => {
    var { iconSize = 20 } = _a, props = __rest(_a, ["iconSize"]);
    return (React.createElement(Button, Object.assign({ "aria-label": "back", color: "default", variant: "icon", sx: {
            width: iconSize * 2,
            height: iconSize * 2,
        } }, props),
        React.createElement(ArrowLeftIcon, { sx: {
                fontSize: iconSize,
            } })));
};

export { BackButton };
//# sourceMappingURL=BackButton.js.map
